import { twMerge } from 'tailwind-merge';
import { SelectHTMLAttributes } from 'react';

type SelectProps = {
    invalid?: boolean
    disabled?: boolean
} & SelectHTMLAttributes<HTMLSelectElement>

export const Select = ({ invalid, disabled, children, ...rest }: SelectProps) => {
    return (
        <select
            {...rest}
            disabled={disabled}
            className={twMerge(
                'form-select block w-full rounded-lg border border-surface-3 bg-surface-3 p-2.5 text-on-surface outline-hidden focus:outline-hidden transition-colors hover:bg-surface-5 focus:border-primary focus:bg-surface-5 focus:ring-primary focus-visible:ring-primary',
                disabled && 'cursor-not-allowed bg-surface-1 hover:bg-surface-1',
                invalid && 'border-error focus:border-error focus-visible:ring-error'
            )}
        >
            {children}
        </select>
    );
};
